<template>
  <div>
    <WellBeingWorkshopComp v-bind:mobile="mobile"/>
    <RedirectActivitiesComp v-bind:mobile="mobile"/>
    <FollowUs v-bind:mobile="mobile"/>
  </div>
</template>

<script>
import RedirectActivitiesComp from '@/components/desktop/Activities/RedirectActivitiesComp'
import WellBeingWorkshopComp from '@/components/desktop/Activities/WellBeingWorkshopComp';
import FollowUs from '@/components/desktop/FollowUs'

  export default {
    name: 'AdaptedPhysicalActivities',
    props: ['mobile'],
    components: {
      WellBeingWorkshopComp,
      RedirectActivitiesComp,
      FollowUs
    },
  }
</script>
